import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ErrorState, LoadingState } from '../../components/ui/state';
import { api } from '../../shared/api';
import { DaycareForm, DaycareFormShell, daycareCreatePayload } from './DaycareForm';

export function DaycareCreatePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const dogsQuery = useQuery({ queryKey: ['dogs'], queryFn: () => api.dogs.listAll() });
  const servicesQuery = useQuery({ queryKey: ['services'], queryFn: api.services.list });
  const membershipsQuery = useQuery({ queryKey: ['membership-purchases', 'daycare'], queryFn: () => api.memberships.purchases({ limit: 100 }) });
  const createDaycare = useMutation({
    mutationFn: (values: Parameters<typeof daycareCreatePayload>[0]) => api.daycares.create(daycareCreatePayload(values)),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['daycares'] }),
        queryClient.invalidateQueries({ queryKey: ['membership-purchases'] }),
      ]);
      navigate('/admin/daycares');
    },
  });

  if (dogsQuery.isLoading || servicesQuery.isLoading || membershipsQuery.isLoading) return <LoadingState label="Cargando guarderia" />;
  if (dogsQuery.isError) return <ErrorState message={dogsQuery.error.message} />;
  if (servicesQuery.isError) return <ErrorState message={servicesQuery.error.message} />;
  if (membershipsQuery.isError) return <ErrorState message={membershipsQuery.error.message} />;

  return (
    <DaycareFormShell title="Nueva guarderia">
      <DaycareForm
        initialDate={searchParams.get('date') ?? undefined}
        initialCustomerId={searchParams.get('customerId') ?? undefined}
        initialDogId={searchParams.get('dogId') ?? undefined}
        lookups={{ dogs: dogsQuery.data?.items ?? [], services: servicesQuery.data?.items ?? [], memberships: membershipsQuery.data?.items ?? [] }}
        error={createDaycare.error?.message}
        isSaving={createDaycare.isPending}
        submitLabel="Crear guarderia"
        onSubmit={(values) => createDaycare.mutate(values)}
      />
    </DaycareFormShell>
  );
}
